import { render, staticRenderFns } from "./Dateswitcher.vue?vue&type=template&id=d23c6ea4&scoped=true&"
import script from "./Dateswitcher.vue?vue&type=script&lang=js&"
export * from "./Dateswitcher.vue?vue&type=script&lang=js&"
import style0 from "./Dateswitcher.vue?vue&type=style&index=0&id=d23c6ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23c6ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
